import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import commonTranslations from "./lang/common.json";
import enTranslations from "./lang/en.json";

// Merge translations (common takes precedence, then en.json for any missing keys)
const translations = {
  ...enTranslations,
  ...commonTranslations
};

// Initialize i18n only if it's not already initialized
// This allows the consuming app (like apps/web) to provide its own i18n instance
if (!i18n.isInitialized) {
  // Always use initReactI18next - this is required for useTranslation hook to work
  i18n.use(initReactI18next).init({
    resources: {
      en: {
        common: translations,
        translation: translations
      }
    },
    lng: "en",
    fallbackLng: "en",
    defaultNS: "common",
    ns: ["translation", "common"],
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false
    }
  });
} else {
  // If i18n is already initialized (e.g., by the consuming app),
  // add our translations, merging with existing ones
  const existingCommon = i18n.getResourceBundle("en", "common") || {};
  const existingTranslation = i18n.getResourceBundle("en", "translation") || {};

  i18n.addResourceBundle(
    "en",
    "common",
    {
      ...existingCommon,
      ...translations
    },
    true,
    true
  );

  i18n.addResourceBundle(
    "en",
    "translation",
    {
      ...existingTranslation,
      ...translations
    },
    true,
    true
  );

  // Check if initReactI18next was used - if not, we have a problem
  // because useTranslation won't work without it
  if (!i18n.options.react) {
    console.warn(
      "i18n was initialized without initReactI18next. useTranslation hook may not work correctly."
    );
  }
}

export { i18n };
